import { ButtonBase } from '@mui/material'
import React from 'react'

export function RadioCard({
  selected,
  onClick,
  children,
  ...rest
}: {
  selected: boolean
  onClick: () => void
  children: React.ReactNode
} & React.ComponentProps<typeof ButtonBase>) {
  return (
    <ButtonBase
      {...rest}
      onClick={onClick}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.neutral.lightGray}`,
        borderRadius: 1,
        backgroundColor: theme.palette.background.default,
        p: '6px',
        '&:hover': {
          p: '5px',
          borderWidth: '2px',
          borderColor: theme.palette.secondary.main,
        },
        '&:focus-visible': {
          // 1px less to offset the wider border
          p: '5px',
          borderWidth: '2px',
          borderColor: theme.palette.secondary.main,
        },
        ...(selected && {
          p: '5px',
          borderWidth: '2px',
          borderColor: theme.palette.secondary.main,
          // :todo: figure out what color this is
          backgroundColor: '#F3F9F6',
        }),
      })}
    >
      {children}
    </ButtonBase>
  )
}
